const state = {
    enterpriseUuid: window.localStorage.getItem('enterpriseUuid'),
    enterprise: JSON.parse(window.localStorage.getItem('enterprise')) || null,
    updatedEnterprise: JSON.parse(window.localStorage.getItem('updatedEnterprise')) || null,
    enterpriseSettingsId: null,
};

const mutations = {
    'SET_ENTERPRISE_UUID' (state, enterpriseUuid) {
        state.enterpriseUuid = enterpriseUuid;
        window.localStorage.setItem('enterpriseUuid', enterpriseUuid);
    },
    'DELETE_ENTERPRISE_UUID' (state) {
        state.enterpriseUuid = null;
        window.localStorage.removeItem('enterpriseUuid');
    },
    'SET_ENTERPRISE' (state, enterprise) {
        state.enterprise = enterprise;
        window.localStorage.setItem('enterprise', JSON.stringify(enterprise));
    },
    'DELETE_ENTERPRISE' (state) {
        state.enterprise = null;
        window.localStorage.removeItem('enterprise');
    },
    'SET_UPDATED_ENTERPRISE' (state, updatedEnterprise) {
        state.updatedEnterprise = updatedEnterprise;
        window.localStorage.setItem('updatedEnterprise', JSON.stringify(updatedEnterprise));
    },
    'DELETE_UPDATED_ENTERPRISE' (state) {
        state.updatedEnterprise = null;
        window.localStorage.removeItem('updatedEnterprise');
    },
    'SET_ENTERPRISE_SETTINGS_ID' (state, enterpriseSettingsId) {
        state.enterpriseSettingsId = enterpriseSettingsId;
    },
};

const actions = {
    async setEnterpriseData({ commit }, enterprise) {
        commit('SET_ENTERPRISE_UUID', enterprise.uuid);
        commit('SET_ENTERPRISE', enterprise);
    },
    async setEnterpriseSettingsId({ commit }, enterpriseSettingsId) {
        commit('SET_ENTERPRISE_SETTINGS_ID', enterpriseSettingsId);
    },
    async clearEnterpriseData({ commit }) {
        commit('DELETE_ENTERPRISE_UUID');
        commit('DELETE_ENTERPRISE');
    },
    async setUpdatedEnterpriseData({ commit }, updatedEnterprise) {
        commit('SET_UPDATED_ENTERPRISE', updatedEnterprise);
    },
    async clearUpdatedEnterpriseData({ commit }) {
        commit('DELETE_UPDATED_ENTERPRISE');
    }
};

const getters = {
    enterpriseUuid: state => state.enterpriseUuid,
    enterpriseName: state => state.enterprise ? state.enterprise.name : null,
    enterprise: state => state.enterprise,
    updatedEnterprise: state => state.updatedEnterprise
};

export default {
    state,
    mutations,
    actions,
    getters
};